import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import stateLayer from '../../helper-components/state-layer/state-layer.vue';
import { IButtonProps, isTFullSize } from './custom-button.types';

import googleMaterialIcon from '../../helper-components/google-material-icon/google-material-icon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-button',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
            'custom-button',
            'custom-button_size_' + __props.props.size,
            'custom-button_type_' + __props.props.type,
        ])
  }, [
    _createVNode(stateLayer, {
      class: _normalizeClass([
                'custom-button__state-layer',
                'custom-button__state-layer_size_' + __props.props.size,
            ])
    }, {
      default: _withCtx(() => [
        _createVNode(googleMaterialIcon, {
          props: {
                    iconName: __props.props.iconName,
                    selected: true,
                }
        }, null, 8, ["props"]),
        (_unref(isTFullSize)(__props.props.size))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass([
                    'custom-button__title',
                    'custom-button__title_size_' + __props.props.size,
                ])
            }, _toDisplayString(__props.props.innerText), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"])
  ], 2))
}
}

})